import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PlayIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 5.14V18.86C8 19.64 8.85 20.12 9.52 19.71L18.51 12.85C19.16 12.45 19.16 11.55 18.51 11.15L9.52 4.29C8.85 3.88 8 4.36 8 5.14Z"
      fill="currentColor"
    />
  </svg>
);

PlayIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PlayIcon);
